import { Component, inject, OnInit } from '@angular/core';
import { DacService } from '../dac.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TaskHistory } from '@/types';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { getDacTaskHistoryDataTableStructure } from './utils/dac-task-history.data-table-object';

@Component({
  selector: 'sm-task-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './task-history.component.html',
  styleUrl: './task-history.component.scss',
})
export class DacTaskHistoryComponent implements OnInit {
  dacService = inject(DacService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  breadcrumb = [
    {
      label: 'dac.title',
      routerLink: ['/dac'],
    },
    {
      label: 'dac.pages.task_history',
      routerLink: ['/dac-task-history'],
    },
  ];

  processInstanceId = this.activatedRoute.snapshot.params['processInstanceId'];

  loading = true;
  data: TaskHistory[] = [];
  datatableObject: DynamicDataTable = getDacTaskHistoryDataTableStructure({
    translate: (key: string) => this.translate.instant(key),
  });

  ngOnInit(): void {
    if (!this.processInstanceId) return;
    this.dacService.getDacTaskHistory(this.processInstanceId).subscribe(history => {
      this.data = history;
      this.loading = false;
    });
  }
}
